<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!solicitacoesDevolucaoHonra || !solicitacoesDevolucaoHonra.length">
      Não foram encontradas solicitações de devolucao com os filtros informados.
    </div>

    <div class="row" *ngIf="solicitacoesDevolucaoHonra && solicitacoesDevolucaoHonra.length">
      <div>
        <button class="btn btn-secondary float-end" type="button" (click)="exportarDevolucao()"
          placement="top" ngbTooltip="Exporta todas as recuperações de crédito listadas">
        <i class="fa fa-file"></i> Exportar Recuperações</button>

        <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
      </div>

      <bn-paginacao [total]="atributosPaginacao.count"
        [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
        [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th id="col-agente" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'id'"
                    [nomeAtributoExibicao]="'ID'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-agente" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjAgenteFinanceiro'"
                    [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-id-operacao-externo" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idOperacaoExterno'"
                    [nomeAtributoExibicao]="'Id. ext. operação'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-contrato" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'contratoRepasse'"
                    [nomeAtributoExibicao]="'Sist./Contrato'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th id="col-data-envio" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'"
                    [nomeAtributoExibicao]="'Data de envio'" (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>

                <th id="col-estado" scope="col">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'estado'" [nomeAtributoExibicao]="'Estado'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
                <th scope="col"></th> <!--lupa para visualizar os detalhes-->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let devolucao of solicitacoesDevolucaoHonra" id="pointer" [routerLink]="['/devolucao/cadastro', devolucao.id]" >
                <td>{{ devolucao.id }}</td>
                <td>{{ nomeAgente(devolucao.cnpjAgenteFinanceiro) }}</td>
                <td>{{ devolucao.idOperacaoExterno }}</td>
                <td>{{ devolucao.contratoRepasse ? devolucao.sistemaRepasse + '/' + devolucao.contratoRepasse : ''}}</td>
                <td>{{ devolucao.dataEnvio | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td>{{ devolucao.estado.nomeEstado }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </bn-paginacao>
    </div>
  </div>
